import { useOaCostRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetOaCostCommonInfoQuery } from "../../features/api/oaCostApi";

export { useOaCostRoutes };

export default GetDefaultIndex({
  title: "سربار و اداری",
  query: useGetOaCostCommonInfoQuery,
});
